<template>
  <div>
    <div class="text-center">
      <h2  class="font-weight-light">Purchases</h2>
    </div>

    <v-container>
      <v-row dense>
        <v-col cols="12">
          <v-card class="mb-5" v-for="purchase in purchases" :key="purchase.id">
            <v-card-title class="headline">
              Description: {{purchase.description}}
            </v-card-title>

            <v-card-text>
              <p>Order Placed: {{ unixEpochToHumanDateTime(purchase.created) }}</p>
              <p>Total: {{ centsToDollars(purchase.amount) }} {{ purchase.currency }}</p>
            </v-card-text>

            <v-card-actions>
              <v-btn :href="purchase.receipt_url" target="_blank">
                View Receipt
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div> 
</template>

<script>
import utils from "@/utils/utils.js";

export default {
  name: "Purchases",
  data() {
    return {
      loading: false,
      purchases: []
    }
  },
  beforeMount(){
    this.fetchData()
  },
  methods: {
    unixEpochToHumanDateTime(duration){
      return utils.unixEpochToHumanDateTime(duration);
    },
    centsToDollars(cents){
      return cents / 100;
    },
    fetchData(){
      this.$axios.get(this.$cfg.ACCOUNTS_API_URL + 's/charges')
        .then((response)=>{
          this.purchases = response.data
        })
        .catch((error) => {
          if (!error.response) {
            this.$store.dispatch("addNotification", {
              type: "error",
              message: "Network Error",
            });
          } else if (error.response.data.errors) {
            this.$store.dispatch("addNotification", {
              type: "error",
              message: error.response.data.errors,
            });
          } else {
            this.$store.dispatch("addNotification", {
              type: "error",
              message: 'Unknown Error, Please contact support.',
            });
          }
        })
    }
  }
}
</script>
